import { ResReadGameSettingType } from '@/types';
import { Box, Typography } from '@mui/material';
import { Tables } from '@/component/pools/table/Tables';
import { packBigNumbers } from '@/lib/BigNumbers';
import BigNumber from 'bignumber.js';
import { gameSettingColumns } from '../table/DashboardData';

export default function GameSetting({ datas }: { datas: ResReadGameSettingType[] }) {
  let total_amount = BigNumber(0);
  let jackpot_amount = BigNumber(0);
  let jackpot_ready = BigNumber(0);

  const list: ResReadGameSettingType[] = datas.map((data: ResReadGameSettingType) => {
    total_amount = total_amount.plus(data.tot_amount);
    jackpot_amount = jackpot_amount.plus(data.jackpot_amount);
    jackpot_ready = jackpot_ready.plus(data.jackpot_ready);

    return {
      game_setting_id: data.game_setting_id,
      name: data.name,
      tot_amount: packBigNumbers(data.tot_amount),
      type: data.type,
      min_tot_amount: packBigNumbers(data.min_tot_amount),
      jackpot_amount: packBigNumbers(data.jackpot_amount),
      jackpot_ready: packBigNumbers(data.jackpot_ready),
      bet_limit_max: packBigNumbers(data.bet_limit_max),
      bet_limit_min: packBigNumbers(data.bet_limit_min),
    };
  });

  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        게임 세팅
      </Typography>
      <Box sx={{ width: '100%' }}>
        total: {packBigNumbers(total_amount.toString())} / jackpot_amount: {packBigNumbers(jackpot_amount.toString())} /
        jackpot_ready: {packBigNumbers(jackpot_ready.toString())}
        {list && <Tables list={list} columns={gameSettingColumns} getRowId={(row) => row.game_setting_id} />}
      </Box>
    </Box>
  );
}
